import { writable } from 'svelte/store';
const loading = writable(false);
const blockNumber = writable(null);
const averageGasPriceLastBlock = writable(null);
const withdrawalsLength = writable(null);
const depositsLength = writable(null);
const lastProcessedWithdrawalLeaf = writable(null);
const lastProcessedDepositLeaf = writable(null);
const addressDepositTransactions = writable([]);
const addressWithdrawalTransactions = writable([]);
export { loading, blockNumber, withdrawalsLength, depositsLength, lastProcessedWithdrawalLeaf, lastProcessedDepositLeaf, addressDepositTransactions, addressWithdrawalTransactions, averageGasPriceLastBlock };
